<div class="page-layout simple fullwidth inner-scroll">
    <!-- HEADER -->
    <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="row" fxLayoutAlign="start center">
            <button
                mat-icon-button
                class="mr-0 mr-sm-16"
                [routerLink]=""
                (click)="volver()"
            >
                <mat-icon>arrow_back</mat-icon>
            </button>

            <div
                *ngIf="sucursal"
                fxLayout="column"
                fxLayoutAlign="start start"
                [@animate]="{
                    value: '*',
                    params: { delay: '100ms', x: '-25px' }
                }"
            >
                <div class="h2">SUCURSAL - {{ sucursal.nombre }}</div>

                <div class="subtitle secondary-text">
                    <span>COMUNA - {{ sucursal.comuna.nombre }} </span>
                </div>
            </div>
        </div>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->

    <!--<div class="center p-24 pb-56" fusePerfectScrollbar>-->

    <div class="content" fusePerfectScrollbar>
        <app-tabla-encargados
            *ngIf="encargados"
            [encargados]="encargados"
            [esRepresentante]="esRepresentante"
            [esSupervisor]="esSupervisor"
            (borrarEncargado)="borrarEncargado($event)"
            (editarEncargado)="editarEncargado($event)"
        ></app-tabla-encargados>

        <button
            *ngIf="esRepresentante || esSupervisor"
            mat-fab
            class="accent"
            id="agregar-sucursal-button"
            (click)="nuevoEncargado()"
            aria-label="Nuevo encargado"
            [@animate]="{
                value: '*',
                params: { delay: '300ms', scale: '.2' }
            }"
        >
            <mat-icon>add</mat-icon>
        </button>
    </div>
    <!--</div>-->

    <!-- / CONTENT -->
</div>
